import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useCashSnapshot = (): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.Banking);

  return useQuery([ReactQueryKeys.CashSnapshot], async () => {
    const response = await treasureApi().get('/dashboard/snapshot');

    return response.data;
  });
};
